import React, { useEffect, useState } from 'react'
import HeaderPage from '../components/homePage/HeaderPage'
import FooterPage from '../components/homePage/FooterPage'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
import HeaderUser from '../components/homePage/HeaderUser';




function TermsAndCondition() {
  const { userDetailLogin } = useSelector((state) => state.auth);
    const API_URL = process.env.REACT_APP_BASE_URL_API || "";
  
    const [terms, setTerms] = useState("");
    const [loading, setLoading] = useState(false);
  
    const fetchTermsCondition = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_URL}/api/front/terms-condition`);
        const result = await res.json();
  
        if (result.status && result.data) {
          setTerms(result.data.content);
        }
      } catch (error) {
        console.error("Terms and condition fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchTermsCondition();
    }, []);


  return (
    
    <>
    { userDetailLogin?._id ? <HeaderUser /> : <HeaderPage /> }
    <>
  <section className="inrbnr">
    <div className="container-fluid con-flu-padd">
      <div className="inrbnrContent">
        <h1>Terms & Conditions</h1>
        <ul className="inrbrnNav">
          <li>
            <Link to={userDetailLogin?._id ? '/dashboard':'/'}>
              <img src="assets/img/icons/home.png" alt="home icon" />
            </Link>
            <img src="assets/img/icons/arrows.png" alt="arrows icons" />
          </li>
          <li>
            <Link to="#">Terms & Conditions</Link>
          </li>
        </ul>
      </div>
    </div>
  </section>
  {/* Section End */}
  <section>
    <div className="register-sec">
      <div className="container-fluid con-flu-padd term-page">
        <div className='mx-2 py-5'>
           {loading ? (
                <p>Loading...</p>
            ) : (
                <div
                dangerouslySetInnerHTML={{ __html: terms }}
                />
            )}
        </div>
      </div>
    </div>
  </section>
</>



    <FooterPage /> 

     
    </>
    
  )
}

export default TermsAndCondition
